module.exports = __webpack_public_path__ + "media/images/icons/mail-bad287e5c0e117ced9a8181fe27a9192.svg";